import React from 'react';
import { useStoreContext } from '../../Contexts/StoreContext';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import Button from '../Form/Button';
import { ORDER_TYPE_ICONS, ORDER_TYPE_LABELS } from '../../Utils/Constants/Service';
import { formatCurrentAddress } from '../../Utils/Formatters';
import { TbCaretDownFilled } from 'react-icons/tb';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useTranslation } from 'react-i18next';

interface BoxContentStoreOrderTypeHeaderProps {
    sizeButton?: number;
}

const BoxContentStoreOrderTypeHeader = ({ sizeButton }: BoxContentStoreOrderTypeHeaderProps) => {

    const { t } = useTranslation();
    const { currentStore, checkStoreOpen, currentAddress } = useStoreContext();
    const { orderType, getOrderTypeIdByName, isDelivery, isStoreCounter } = useOrderTypeContext();
    const { setShowStart } = useLayoutContext();
    const IconOrderType = ORDER_TYPE_ICONS[orderType as keyof typeof ORDER_TYPE_ICONS];
    const isStoreClosed = orderType && !checkStoreOpen(Number(getOrderTypeIdByName(orderType)))

    return (
        <div className="flex items-center w-full md:w-auto h-full gap-3 text-gray-400">
            <div className={`grid w-full gap-1 text-right ${isDelivery && 'cursor-pointer'}`} onClick={() => isDelivery ? setShowStart(true) : {}}>

                {isDelivery &&
                    <div className="flex gap-0.5 text-xs font-bold leading-none md:text-nowrap text-shopfood-title justify-end">
                        { currentAddress ? formatCurrentAddress(currentAddress, true) : t('header.current_address_not_selected_label') }
                        <div className="-mr-0.5"><TbCaretDownFilled className='text-custom-primary leading-none' /></div>
                    </div>
                }

                <div className="flex w-full flex-col leading-none md:text-nowrap">
                    <div className='text-sm font-medium leading-none'>{currentStore.name}</div>
                    {currentStore.neighborhood && !isDelivery && <div className='text-xs leading-none'>{currentStore.neighborhood}</div>}
                </div>

            </div>

            {orderType &&
                <Button
                    onClick={() => setShowStart(true)}
                    disabled={isStoreCounter}
                    className="rounded-md aspect-square flex-col px-[0.5em] h-16 gap-0.5 text-shopfood-title disabled:bg-gray-100 disabled:ring-transparent">
                    <div><IconOrderType size={sizeButton} /></div>
                    <span className='text-xs leading-none'>{ORDER_TYPE_LABELS[orderType as keyof typeof ORDER_TYPE_LABELS]}</span>

                    {isStoreClosed 
                        ? <div className='text-nowrap font-medium leading-none rounded-full text-xs text-gray-400'>{t('layout.store_closed_label')}</div>
                        : (isDelivery && currentStore && currentStore.shipping_time && currentStore.shipping_time > 0) && 
                            <div className='text-nowrap font-medium leading-none rounded-full text-xs text-gray-400'>
                                <span>{currentStore.shipping_time} {t('header.shipping_time.minutes')}</span>
                            </div>
                    }
                </Button>
            }
        </div>
    );
};

export default BoxContentStoreOrderTypeHeader;
